'use client';

import React, { useMemo } from 'react';

import FormSection from '@/components/forms/FormSection/FormSection';
import { SmartFormBlock } from '@/components/forms/SmartFormBlock/SmartFormBlock';
import type { LovedayContactSection } from '@/features/loveday/hooks/fetchData';

function segmentsToMarkdown(
  paragraphs: {
    segments: { text: string; href?: string; variant?: string }[];
  }[],
): string {
  return paragraphs
    .map((p) =>
      p.segments
        .map((seg) => {
          if (seg.href) return `[${seg.text}](${seg.href})`;
          if (seg.variant === 'strong') return `**${seg.text}**`;
          return seg.text;
        })
        .join(''),
    )
    .join('\n\n');
}

export const ContactFormSection = ({
  data,
}: {
  data?: LovedayContactSection;
}): React.ReactElement | null => {
  const descriptionContent = useMemo(() => {
    if (!data) return '';
    if (data.descriptionParagraphs)
      return segmentsToMarkdown(data.descriptionParagraphs);
    return data.description || '';
  }, [data]);

  if (!data) return null;

  return (
    <FormSection
      id="love-day-form"
      className="mb-8!"
      heading={{ content: data.heading || 'Enquire About Loveday' }}
      description={
        descriptionContent ? { content: descriptionContent } : undefined
      }
      form={
        <SmartFormBlock
          formId="serviceEnquiry"
          submitLabel="Send Enquiry"
          anchorId="form"
          template="bare"
          metadata={{
            serviceName: 'Loveday',
            pageType: 'service',
            source: 'loveday-page',
          }}
        />
      }
    />
  );
};
